import { Breadcrumb, Flex } from 'antd'
import { FlexProps } from 'antd/lib'
import { PropsWithChildren, ReactNode } from 'react'

import { Title } from 'src/components'
import { useLocales } from 'src/locales'

import { BackButton } from '../BackButton'

import { useStyles } from './styles'

type Props = {
  title?: string
  items: {
    path?: string
    title: string
  }[]
  patientInformation?: ReactNode
  extra?: ReactNode
  extraProps?: Omit<FlexProps, 'children'>
  /** Shows a back button before the title (previous page, else the last breadcrumb with a path). */
  showBack?: boolean
} & PropsWithChildren

export const PageBreadcrumbs = ({
  title,
  items,
  children,
  patientInformation,
  extra,
  extraProps,
  showBack
}: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()

  const mappedItems = items.map((item) => {
    return {
      href: item.path,
      title: item.title
    }
  })

  return (
    <Flex vertical>
      <Flex
        justify="space-between"
        align="center"
        className={styles.wrapper}
        {...extraProps}
      >
        <Flex gap={8} vertical className="full-width">
          <Breadcrumb
            items={[
              {
                title: t('pageHeader.main_page')
              },
              ...mappedItems
            ]}
          />

          <Flex gap={8} align="center" justify="space-between">
            <Flex gap={12} align="center">
              {showBack && (
                <BackButton
                  fallbackPath={
                    [...items].reverse().find((item) => item.path)?.path ?? '/'
                  }
                />
              )}
              <Title level={4} weight={700}>
                {title}
              </Title>
            </Flex>
            {extra}
          </Flex>

          {patientInformation}
        </Flex>
      </Flex>
      {children}
    </Flex>
  )
}
